var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonitoringIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1259_1661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 1C11.8661 1 15 4.1339 15 8C15 11.8661 11.8661 15 8 15C4.1339 15 1 11.8661 1 8C1 4.1339 4.1339 1 8 1ZM8 3.8C7.81435 3.8 7.6363 3.87375 7.50503 4.00503C7.37375 4.1363 7.3 4.31435 7.3 4.5V8C7.30004 8.18564 7.37382 8.36365 7.5051 8.4949L9.6051 10.5949C9.73712 10.7224 9.91394 10.793 10.0975 10.7914C10.281 10.7898 10.4566 10.7162 10.5864 10.5864C10.7162 10.4566 10.7898 10.281 10.7914 10.0975C10.793 9.91394 10.7224 9.73712 10.5949 9.6051L8.7 7.7102V4.5C8.7 4.31435 8.62625 4.1363 8.49497 4.00503C8.3637 3.87375 8.18565 3.8 8 3.8Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1259_1661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitoringIcon);
export default __webpack_public_path__ + "static/media/monitoring_icon.c471e26d94f7fed786f6fa0947073ace.svg";
export { ForwardRef as ReactComponent };